import {
  GetStaticProps,
  GetStaticPropsContext,
  InferGetStaticPropsType,
  NextPage,
} from 'next';

import {
  CookiePolicyDocument,
  CookiePolicyQuery,
  CookiePolicyQueryVariables,
  FooterDocument,
  FooterQuery,
  FooterQueryVariables,
  NavigationDocument,
  NavigationQuery,
  NavigationQueryVariables,
} from '@/api';
import { addApolloState, initializeApollo } from '@/api/apolloClient';
import { Layout } from '@/components/layout/Layout';
import EnhancedPolicyPageWrapper from '@/components/policies/EnhancedPolicyPageWrapper';
import { Seo } from '@/components/Seo';

export const getStaticProps: GetStaticProps = async (
  context: GetStaticPropsContext,
) => {
  const client = initializeApollo();
  const { locale } = context;

  // prefetch
  await client.query({ query: NavigationDocument });
  await client.query({ query: CookiePolicyDocument });
  await client.query({ query: FooterDocument });

  const { data: footerData } = await client.query<
    FooterQuery,
    FooterQueryVariables
  >({ query: FooterDocument, variables: { locale: locale || 'en' } });

  const { data: headerData } = await client.query<
    NavigationQuery,
    NavigationQueryVariables
  >({ query: NavigationDocument, variables: { locale: locale || 'en' } });

  const { data: cookiePolicy } = await client.query<
    CookiePolicyQuery,
    CookiePolicyQueryVariables
  >({
    query: CookiePolicyDocument,
    variables: { locale: locale || 'en' },
  });
  return addApolloState(client, {
    props: {
      cookiePolicy,
      footerData,
      headerData,
    },
  });
};

const CookiePolicy: NextPage<
  InferGetStaticPropsType<typeof getStaticProps>
> = ({ footerData, headerData, cookiePolicy }) => (
  <Layout invertedColor footerData={footerData} headerData={headerData}>
    <Seo seo={cookiePolicy?.cookiePolicy.data?.attributes?.seo} />
    <EnhancedPolicyPageWrapper
      data={cookiePolicy?.cookiePolicy.data?.attributes?.cookiePolicy}
    />
  </Layout>
);

export default CookiePolicy;
